import script from "./TabbarOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabbarOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./TabbarOrganism.css?vue&type=style&index=0&id=334ea926&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334ea926"]])

export default __exports__